import referrerType from './referrer-type'

export default {
  name: 'BaseInfoClub',
  path: 'club',
  meta: {
    label: 'club',
    auth: 'club'
  },
  component: {
    name: 'Club',
    render(c) {
      return c('router-view')
    }
  },
  children: [referrerType]
}
